import { computed, inject, Injectable } from '@angular/core';
import { EmpresaComContexto } from '../models/empresa-com-contexto';
import { TenantContextService } from './tenant-context.service';

/**
 * Fachada mantida por compatibilidade (Bloco 6, Opção A da spec): `companyId` e
 * `defaultCompany` delegam para `TenantContextService` (que deriva do cache de
 * `GET /user/me/empresas` + cookie). Assim `purchasing.service`, `user.service`
 * e `chat-api.service` não mudam.
 *
 * O código morto do `channel*` (removido no PR #137) não voltou aqui — esta
 * classe hoje só trata de empresa.
 */
@Injectable({ providedIn: 'root' })
export class CompanyContextService {
  private readonly _tenant = inject(TenantContextService);

  /** Empresa (tenant) atual — vem do cache do `TenantContextService`. */
  readonly defaultCompany = computed<EmpresaComContexto | null>(() =>
    this._tenant.empresaAtual()
  );

  readonly companyId = computed(() => this._tenant.companyId());
}
